import { mergeProductAndVariant } from './Amalgam';
import { getProduct } from './Product';
import { getImageId } from './Utils';

let customPageAmalgam = {};

export const setCustomPageAmalgamObject = (amalgam) => {
  customPageAmalgam = amalgam;
  if (!customPageAmalgam.customPage) {
    customPageAmalgam.customPage = {};
  }
  if (!customPageAmalgam.customPage.products) {
    customPageAmalgam.customPage.products = [];
  }
  const productIds = amalgam.customPage.products.map((product) => product.id);
  mergeProductsIntoDefaultVariants({ productIds });
};
export const getCustomPage = () => (customPageAmalgam || {}).customPage || {};
export const getCustomPageId = () => ((customPageAmalgam || {}).customPage || {}).id;
export const getCustomPageSections = () => getCustomPage().sections || [];
export const getCustomPageSection = (sectionId) =>
  getCustomPageSections().find((section) => section.id === sectionId) || {};
export const getCustomPageProducts = () => getCustomPage().products || [];
export const getCustomPageHiddenCatalogueActionButtonThemes = () =>
  getCustomPage().hiddenCatalogueActionButtonThemes || [];
export const getCustomPageProduct = (productId) =>
  getCustomPageProducts().find((product) => product.id === productId) || {};
export const getCustomPageSectionHiddenCatalogueId = (sectionId) => {
  const sections = getCustomPage().sections || [];
  const section = sections.find((section) => section.id === sectionId);
  if (section) {
    // Note: do not allow returning undefined here, need to return null instead
    return section.hiddenCatalogueId || null;
  }
  return null;
};
export const getCustomPageAmalgamObject = () => customPageAmalgam;
export const setCustomPageProduct = ({ productId, mergedProduct }) => {
  if (!customPageAmalgam) {
    customPageAmalgam = { customPage: {} };
  }
  if (!customPageAmalgam.customPage.products) {
    customPageAmalgam.customPage.products = [];
  }
  const index = customPageAmalgam.customPage.products.findIndex(
    (product) => product.id === productId
  );
  if (index > -1) {
    customPageAmalgam.customPage.products[index] = mergedProduct;
  }
};
export const setCustomPageCatalogues = (catalogues) => {
  if (!customPageAmalgam) {
    customPageAmalgam = { customPage: {} };
  }
  customPageAmalgam.customPage.catalogues = catalogues;
};
export const setCustomPageHiddenCatalogueActionButtonThemes = (
  hiddenCatalogueActionButtonThemes
) => {
  if (!customPageAmalgam) {
    customPageAmalgam = {
      customPage: {}
    };
  }
  customPageAmalgam.customPage.hiddenCatalogueActionButtonThemes =
    hiddenCatalogueActionButtonThemes;
};
export const setCustomPageProducts = (products) => {
  if (!customPageAmalgam) {
    customPageAmalgam = { customPage: {} };
  }
  customPageAmalgam.customPage.products = products;
};
export const setCustomPageSingleShowcases = (singleShowcases) => {
  if (!customPageAmalgam) {
    customPageAmalgam = { customPage: {} };
  }
  customPageAmalgam.customPage.singleShowcases = singleShowcases;
};
export const setCustomPageGroupShowcases = (groupShowcases) => {
  if (!customPageAmalgam) {
    customPageAmalgam = { customPage: {} };
  }
  customPageAmalgam.customPage.groupShowcases = groupShowcases;
};
export const setCustomPageSections = (sections) => {
  if (!customPageAmalgam) {
    customPageAmalgam = { customPage: {} };
  }
  customPageAmalgam.customPage.sections = sections;
};
export const mergeProductsIntoDefaultVariants = ({ productIds }) => {
  if (!productIds) {
    return;
  }
  const fromCustomPage = true;
  productIds.forEach((productId) => {
    const product = getProduct(productId, fromCustomPage);

    if (!product || !product.parentProductId) {
      return;
    }

    const parentProduct = getProduct(product.parentProductId, fromCustomPage);
    if (parentProduct) {
      const mergedProduct = mergeProductAndVariant(parentProduct, product, fromCustomPage);
      if (mergedProduct) {
        setCustomPageProduct({ mergedProduct, productId });
      }
    }
  });
};

export const getPictureForProduct = ({ product }) => {
  let picture;
  const { pictureUrl } = product;

  if (
    !pictureUrl &&
    product.default_picture_id &&
    product.pictures &&
    product.pictures[product.default_picture_id] &&
    product.pictures[product.default_picture_id].url
  ) {
    picture = product.pictures[product.default_picture_id];
  }

  if (!pictureUrl && product.pictures && Object.keys(product.pictures).length > 0) {
    const availableUrlInpictureId = Object.keys(product.pictures).find(
      (pictureId) => !!(product.pictures[pictureId] || {}).url
    );
    picture = (product.pictures[availableUrlInpictureId] || {}).url;
  }

  if (!picture) {
    if (pictureUrl) {
      const pictureId = getImageId(pictureUrl);
      if (pictureId && product.pictures[pictureId] && product.pictures[pictureId].url) {
        picture = product.pictures[pictureId];
      }
    } else if (
      product.default_picture_id &&
      product.pictures &&
      product.pictures[product.default_picture_id] &&
      product.pictures[product.default_picture_id].url
    ) {
      picture = product.pictures[product.default_picture_id];
    }
  }

  return picture;
};

export const getPictureUrlForCatalogue = ({ product }) => {
  let { pictureUrl } = product;

  if (
    !pictureUrl &&
    product.default_picture_id &&
    product.pictures &&
    product.pictures[product.default_picture_id] &&
    product.pictures[product.default_picture_id].url
  ) {
    pictureUrl = product.pictures[product.default_picture_id].url;
  }

  if (!pictureUrl && product.pictures && Object.keys(product.pictures).length > 0) {
    const availableUrlInpictureId = Object.keys(product.pictures).find(
      (pictureId) => !!(product.pictures[pictureId] || {}).url
    );
    pictureUrl = (product.pictures[availableUrlInpictureId] || {}).url;
  }

  return pictureUrl;
};
